<!-- apple -->

<div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
    <div id="embeddedButtons_apple"></div>
    <div fxLayout="row" class="mat-subheading-1 boldest" fxLayoutAlign="center center">
        {{buttonApple ?("or"|translate):" "}} </div>

    <!-- google -->
    <div #embeddedButtons_google2 id="embeddedButtons_google"></div>
    <div fxLayout="row" class="mat-subheading-1 boldest" fxLayoutAlign="center center" >
        {{buttonGoogle ?("or"|translate):" "}} </div>
</div>